<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout column align-center justify-center>
          <h1 class="orange--text text-uppercase">Account Suspended</h1>
          <v-subheader>This account has been suspended.</v-subheader>
          <p>
            <img
                :src="require('../assets/FullNameLogo.png')"
                alt="Scorebook"
                style="width:25vw;max-width:150px;">
          </p>
          <p>
            <img
                :src="require('../assets/sad.svg')"
                style="width:30vw;max-width:180px;"
                alt="sad face">
          </p>
          <v-btn
              round
              color="warning"
              @click="signout"
              :loading="isLoading"
          >
            sign out
          </v-btn>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Suspended",
        computed: {
            ...mapGetters('auth', ['isSuccess', 'isLoading']),
        },
        methods: {
            signout() {
                this.$store.dispatch('auth/signout')
                    .then(() => {
                        if (this.isSuccess)
                            this.$router.push('/')
                    })
            }
        }
    }
</script>

<style scoped>

</style>
